import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=4b28e7fa&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports